export const INSERT_LEAVE_CATEGORY_MUTATION = `
  mutation InsertLeaveCategory($input: LeaveCategoryInsertInput!) {
    insertLeaveCategory(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_LEAVE_CATEGORY_MUTATION = `
  mutation UpdateLeaveCategory($filter: String!, $input: LeaveCategoryUpdateInput!) {
    updateLeaveCategory(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_LEAVE_CATEGORY_MUTATION = `
  mutation DeleteLeaveCategory($filter: String!, $input: LeaveCategoryDeleteInput!) {
    deleteLeaveCategory(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;
